const initializeSession = user => {
  if (user) {
    if (user.chat_session && !window.CRISP_TOKEN_ID) {
      window.CRISP_TOKEN_ID = user.chat_session.token;
      $crisp.push(["do", "session:reset"]);
    }

    $crisp.push([
      "on",
      "session:loaded",
      () => {
        if ($crisp.get("user:email") === user.email) {
          return;
        }

        $crisp.push(["set", "user:email", [user.email]]);
        $crisp.push([
          "set",
          "user:nickname",
          [`${user.first_name} ${user.last_name}`]
        ]);
        $crisp.push(["set", "user:avatar", [user.profile.profile_picture]]);
        $crisp.push([
          "set",
          "session:data",
          [
            [
              ["accountable_type", user.accountable_type],
              ["accountable_id", user.accountable.id],
              ["member_since", user.created_at]
            ]
          ]
        ]);
      }
    ]);
  }
};

const clearSession = () => {
  $crisp.push(["do", "session:reset"]);
};

const openChat = () => {
  $crisp.push(["set", "message:text", [""]]);
  $crisp.push(["do", "chat:open"]);
};

const requestEmailChange = () => {
  const message =
    "Olá,\n\nNão estou conseguindo confirmar o meu email e gostaria de solicitar a sua alteração para o email abaixo:\n\n< inserir novo email aqui >";

  $crisp.push(["set", "message:text", [message]]);
  $crisp.push(["do", "chat:open"]);
};

const sendProofOfPayment = () => {
  const message =
    "Olá,\n\nRealizei uma limpeza e gostaria de enviar o comprovante de pagamento";

  $crisp.push(["set", "message:text", [message]]);
  $crisp.push(["do", "chat:open"]);
};

export default {
  initializeSession,
  clearSession,
  openChat,
  requestEmailChange,
  sendProofOfPayment
};



// WEBPACK FOOTER //
// ./src/utils/support.js